<template>
  <div class="modal show fade modal-primary text-left" style="display: block;" v-if="show">
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" style="text-transform:capitalize;">Onboarding</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="card business-card">
<!--            <div class="card-header" v-show="showOptions">-->
<!--              <h5>Select Avaliable Methods</h5>-->
<!--            </div>-->

            <div class="card-body">
<!--              <div v-show="showOptions">-->
<!--                <div class="business-items"    >-->
<!--                  <div class="business-item" style="cursor: pointer" @click="selectOption('1')">-->
<!--                    <div class="d-flex align-items-center justify-content-between">-->
<!--                      <div class="custom-control custom-radio" >-->
<!--                        <input v-model="selectedOption" type="radio" name="some-radios" class="custom-control-input" value="1" id="__BVID__756">-->
<!--                        <label class="custom-control-label" for="__BVID__756"> Add sub-entity details now </label>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->

<!--                </div>-->
<!--                <button type="button" class="btn btn-primary btn-block" @click="confirmSelection">Continue</button>-->
<!--              </div>-->

              <Form v-slot="{ validate: validateForm1, values: form1Values }" ref="form1" class="mb-4" >
                  <fieldset class="form-group" id="__BVID__896">
                    <div>
                      <label for="parentEntity">Parent Entity</label>
                      <Field v-model="parentEntity"  name="parentEntity" placeholder="Parent Entity"  rules="required" class="form-control"/>
                      <ErrorMessage name="parentEntity" class="text-danger" />

<!--                      <input v-model="parentEntity" type="text" placeholder="Parent Entity" class="form-control" id="parentEntity" >-->
                    </div>
                  </fieldset>

                  <fieldset class="form-group" id="__BVID__898">
                    <label for="uniqueRef">Unique Reference</label>
                    <Field v-model="uniqueRef"  name="uniqueRef" placeholder="Reference"  rules="required" class="form-control"/>
                    <ErrorMessage name="uniqueRef" class="text-danger" />
                  </fieldset>
                </form>
                <button type="button" class="btn btn-primary mr-1 "   @click="navigateToActivation">Continue</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="show" class="modal-backdrop fade show"></div>
</template>

<script>

import {ErrorMessage, Field} from "vee-validate";

export default {
  components: {ErrorMessage, Field},
  props: ['show', 'data', 'index'],
  data() {
    return {
      list: [],
      parentEntity: '',
      uniqueRef: '',
      selectedOption: null,
      option:null,
      showOptions: true,
      // showModal: false,
    }
  },
  mounted() {
    // this.list = this.data
  },
  methods: {
    async navigateToActivation() {

      const form1 = this.$refs.form1; // Reference to Form 1

      // Validate each form
      const form1Result = await form1.validate();

      if (form1Result.valid) {
        const uniqueRef = this.uniqueRef || 'default-ref';
        const parentEntity = this.parentEntity || 'default-entity';
        this.$router.push({
          name: 'account-activation',
          params: { uniqueRef, parentEntity },
        });
      }

      return

    },
    selectOption(option) {
      this.selectedOption = option;
    },
    backToOptions() {
      this.showOptions = true
      this.option = null
    },
    confirmSelection() {
      this.showOptions = false
      this.option = this.selectedOption
    },
  },
  watch: {
    show() {
      this.list = this.data
    },
  }
}
</script>


